export default __webpack_public_path__ + "static/media/reg_roleplay.2a0f17a2.pdf";